import {PWMAT_RESOURCE} from './consts'

export const QuickStartTutorial = [
  {
    name:'快速上手教程',
    url:PWMAT_RESOURCE+'quick_start_tutorial.pdf',
    file_name:'quick_start_tutorial.pdf'
  },
  ]
